import { useEffect, useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";

import { getClientId, getCaseId } from "../../Utils/helper";
import { setHeaderName } from "../../Redux/header_name/action";
import { api_without_cancellation } from "../../api/api";
import { setPageId } from "../../Redux/getPageId/action";
import "./navbarLinks.css";
import DocumentUploadModal from "../Modals/documentUploadModal";
import { UploadDocumentsForInbox } from "../../Providers/main";
import { setInboxRefreshDocuments } from "../../Redux/inbox/actions";
// import ModalComponent from "../NewCaseModal/ModalComponent";
import settingsIcon from "../../assets/images/settings_icon.png";
import UserPreference from "../Home/UserPrefrence";
import { Stages } from "../common/CaseStage";
import gaugeIcon from "../../assets/checklist/Gauge-Page-icon.svg";
import chatIcon from "../../assets/chat-page-icon.svg";
import useNotificationCounts from "../AChatWindow/hooks/useNotificationsCount";
import { useStageWebSocket } from "../../Hooks/useStageWebSocket";
import { updateCaseStage } from "../../Redux/caseData/caseDataSlice";
import { useLiveWorklistCount } from "../Sidebars/useWorklistCount";
import { NAVBAR_ROUTES } from "../../Routes/routeAccessPolicy.mjs";

const buildCaseRoute = (path, clientId, caseId) =>
  path && clientId && caseId ? `/${path}/${clientId}/${caseId}` : "/search/";

const addClickRecord = async (clickId, pageId, dispatch) => {
  const caseId = getCaseId();
  const clientId = getClientId();
  if (!caseId || !clientId) return;
  try {
    const payload = {
      page_id: pageId,
      click: clickId,
      case_id: caseId,
      client_id: clientId,
    };
    dispatch(setPageId(pageId));
    // API call to save click record
    await api_without_cancellation.post("/api/general/click_record/", payload);
  } catch (error) {
    console.error(`Failed to add click record for ${clickId}:`, error);
  }
};

const CustomLink = (
  clickId,
  pageId = undefined,
  path,
  icon,
  badgetCount = 0,
  linkText,
  isDropdownLink
) => {
  const dispatch = useDispatch();
  return (
    <Link
      className={`navbar-icon-button ${isDropdownLink ? "flex-column" : ""}`}
      onClick={() => {
        if (pageId !== undefined) addClickRecord(clickId, pageId, dispatch);
        dispatch(setHeaderName(linkText));
      }}
      to={path}
    >
      <div className="icon-hover-container">
        <div
          className={`${isDropdownLink ? "single-icon-dropdown" : "single-icon"}  ${badgetCount > 0 ? "single-icon-relative" : ""}`}
        >
          {(linkText === "Gauge Page" || linkText === "Chat") && (
            <img className="ic ic-30" src={icon} />
          )}
          {linkText !== "Gauge Page" && linkText !== "Chat" && <i className={`ic ic-30 ${icon}`} />}
          {!isDropdownLink && (
            <small
              className="hover-text"
              style={{
                top: "27px",
              }}
            >
              {linkText}
            </small>
          )}

          {badgetCount > 0 ? (
            <div
              className="count-badge"
              style={{
                right: "-3px",
                top: "-5px",
                height: "14px",
                width: "14px",
                borderRadius: "50%",
                fontSize: "9px",
              }}
              id=""
              role="status"
            >
              {badgetCount}
            </div>
          ) : null}
        </div>
      </div>
      {isDropdownLink && <small className="hover-dropdown-text">{linkText}</small>}
    </Link>
  );
};

const CustomOptions = (onClick, icon, linkText, dropdownOpen) => {
  return (
    <Link className="navbar-icon-button" onClick={onClick}>
      <div className="icon-hover-container">
        <div className={`${dropdownOpen ? "single-icon-dropdown" : "single-icon"}`}>
          <img className="ic ic-30" src={icon} />
          <small
            style={{ marginTop: dropdownOpen ? "2px" : "0px", top: "27px" }}
            className={`${dropdownOpen ? "hover-dropdown-text" : "hover-text"}`}
          >
            {linkText}
          </small>
        </div>
      </div>
    </Link>
  );
};

const useMenuItemsState = () => {
  // const toDoCount = useSelector((state) => state.general.toDoCount);
  const flaggedPageCount = useSelector((state) => state.general.flaggedPageCount);
  const clientId = getClientId();
  const caseId = getCaseId();
  const { global } = useNotificationCounts();
  const liveWorklistC = useLiveWorklistCount();
  const [menuItems, setMenuItems] = useState([
    {
      clickId: 30,
      pageId: 36,
      badgetCount: 0,
      path: buildCaseRoute(NAVBAR_ROUTES.caseNavigator, clientId, caseId),
      linkText: "Case Navigator",
      icon: "ic-case-navigator",
    },
    {
      clickId: 31,
      pageId: undefined,
      badgetCount: liveWorklistC,
      path: buildCaseRoute(NAVBAR_ROUTES.workList, clientId, caseId),
      linkText: "Work List",
      icon: "ic-worklist",
    },
    {
      clickId: 22,
      pageId: 29,
      badgetCount: 0,
      path: buildCaseRoute(NAVBAR_ROUTES.calendar, clientId, caseId),
      linkText: "Calendar",
      icon: "ic-calendar",
    },
    {
      clickId: 34,
      pageId: 44,
      badgetCount: 0,
      path: buildCaseRoute(NAVBAR_ROUTES.gauge, clientId, caseId),
      linkText: "Gauge Page",
      // icon: "ic-speedometer",
      icon: gaugeIcon,
    },
    {
      clickId: 34,
      pageId: 30,
      badgetCount: global,
      path: buildCaseRoute(NAVBAR_ROUTES.chat, clientId, caseId),
      linkText: "Chat",
      icon: chatIcon,
    },
    {
      clickId: 35,
      pageId: 31,
      badgetCount: flaggedPageCount,
      path: buildCaseRoute(NAVBAR_ROUTES.flaggedCases, clientId, caseId),
      linkText: "Flagged Cases",
      icon: "ic-flagged",
    },
    {
      clickId: 37,
      pageId: undefined,
      badgetCount: 0,
      path: buildCaseRoute(NAVBAR_ROUTES.firmReporting, clientId, caseId),
      linkText: "Firm Reporting",
      icon: "ic-reports-updated",
    },
    {
      clickId: undefined,
      pageId: undefined,
      path: buildCaseRoute(NAVBAR_ROUTES.litigationCentral, clientId, caseId),
      linkText: "Litigation Central",
      icon: "ic-litigation",
    },
    {
      clickId: 37,
      pageId: 45,
      badgetCount: 0,
      path: buildCaseRoute(NAVBAR_ROUTES.directory, clientId, caseId),
      linkText: "Firm Management",
      icon: "ic-directory",
    },
    {
      clickId: 38,
      pageId: 37,
      badgetCount: 0,
      path: buildCaseRoute(NAVBAR_ROUTES.accounting, clientId, caseId),
      linkText: "Accounting",
      icon: "ic-accounting",
    },
    {
      clickId: 39,
      pageId: undefined,
      badgetCount: 0,
      path: buildCaseRoute(NAVBAR_ROUTES.library, clientId, caseId),
      linkText: "Library",
      icon: "ic-library",
    },
    {
      clickId: 37,
      pageId: undefined,
      badgetCount: 0,
      path: buildCaseRoute(NAVBAR_ROUTES.copilot, clientId, caseId),
      linkText: "CoPilots",
      icon: "ic-copilot",
    },
    {
      clickId: undefined,
      pageId: undefined,
      linkText: "User Options",
      icon: settingsIcon,
    },
  ]);

  // Utility to update a menu item by linkText (or any other key)
  const updateBadgeCount = (linkText, newCount) => {
    setMenuItems((prev) =>
      prev.map((item) => (item.linkText === linkText ? { ...item, badgetCount: newCount } : item))
    );
  };

  useEffect(() => {
    updateBadgeCount("Chat", global);
  }, [global]);

  useEffect(() => {
    updateBadgeCount("Work List", liveWorklistC || 0);
  }, [liveWorklistC]);

  // useEffect(() => {
  //   updateBadgeCount("Work List", toDoCount);
  // }, [toDoCount]);

  useEffect(() => {
    updateBadgeCount("Flagged Cases", flaggedPageCount);
  }, [flaggedPageCount]);

  return [menuItems, setMenuItems];
};

const NavbarLinks = () => {
  // const stages = useSelector((state) => state?.caseData?.stages);
  const headerData = useSelector((state) => state?.headerData.headerSummary);
  const stages = headerData?.stages_data;
  const [menuItems, _setMenuItems] = useMenuItemsState();
  const navbarContainerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(menuItems.length);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isCollapseAddNewCase, setIsCollapseAddNewCase] = useState(false);
  const [isCollapseInbox, setIsCollapseInbox] = useState(false);

  const inboxRefreshDocuments = useSelector((state) => state.inbox.inboxRefreshDocuments);
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadFile, setUploadFile] = useState("");
  // const [showModal, setShowModal] = useState(false);

  // const handleCloseModal = () => setShowModal(false);
  const dispatch = useDispatch();
  const clientId = getClientId();
  const caseId = getCaseId();

  const { getRootProps, getInputProps } = useDropzone({
    disabled: !clientId || !caseId,
    onDrop: (files) => {
      if (!clientId || !caseId) return;
      setUploadFile(files?.map((file) => file.name));
      setFileUploadModal(true);
      UploadDocumentsForInbox(
        files,
        caseId,
        clientId,
        dispatch,
        inboxRefreshDocuments,
        setInboxRefreshDocuments,
        setUploadProgress
      );
    },
  });

  // WebSocket handler for real-time stage updates
  const handleStageWebSocketUpdate = useCallback(
    (message) => {
      if (message.type === "stage_updated" && message.data) {
        const { stage_id, is_triggered } = message.data;
        // Find the stage from stages_data to get full stage info
        const stageFromData = stages?.find((s) => s.id === stage_id);
        const stageData = message.data.stage ||
          stageFromData || { id: stage_id, name: `Stage ${stage_id}` };
        dispatch(updateCaseStage({ stage_id, stage: stageData, is_triggered }));
      }
    },
    [dispatch, stages]
  );

  // Connect to WebSocket for stage updates
  useStageWebSocket(caseId, handleStageWebSocketUpdate);

  const [isIconsvisible, setIsIconvisible] = useState(window.innerWidth <= 900);
  useEffect(() => {
    const handleResize = () => {
      setIsIconvisible(window.innerWidth <= 900);
      if (!navbarContainerRef.current) return;

      const iconWidth = 33; // width of one icon including margin
      const collapseButtonWidth = 31;
      const gap = 10;
      const caseButtonWidth = 84;
      const inboxButtonWidth = 66;
      const leftPadding = 29;
      // Always measure the container, even when both buttons are collapsed.
      // Depending on collapse state here makes narrow layouts alternate forever.
      const iconRegionWidth =
        navbarContainerRef.current.offsetWidth -
        (iconWidth + gap) -
        collapseButtonWidth -
        caseButtonWidth -
        inboxButtonWidth -
        leftPadding +
        35;
      const maxVisible = Math.floor(iconRegionWidth / (iconWidth + gap));

      setVisibleCount(iconRegionWidth < 60 ? 1 : Math.max(1, maxVisible));
      setIsCollapseAddNewCase(iconRegionWidth < 60);
      setIsCollapseInbox(iconRegionWidth < -50);
    };

    const observer = new ResizeObserver(handleResize);
    const currentRef = navbarContainerRef.current;

    if (currentRef) {
      observer.observe(currentRef);
      handleResize();
    }
    window.addEventListener("resize", handleResize);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const homeMenuItem = {
    clickId: 29,
    pageId: 35,
    badgetCount: 0,
    path: buildCaseRoute(NAVBAR_ROUTES.home, clientId, caseId),
    linkText: "Home",
    icon: "ic-home",
  };
  const visibleMenuItems = menuItems.slice(0, visibleCount - 1);
  const hiddenMenuItems = menuItems.slice(visibleCount - 1);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const handleSettingsClick = () => {
    setIsSettingsOpen((prev) => !prev);
  };

  const addNewCaseDiv = (
    <div
      className="case-btn icon-hover-container add-case-btn"
      style={{
        ...(!isCollapseAddNewCase
          ? {
              left: "-10px",
              marginRight: "5px",
              marginTop: "5px",
              position: "relative",
            }
          : {
              marginRight: "0px",
              marginTop: "0px",
              position: "unset",
              left: "0px",
            }),
      }}
    >
      <Link to={buildCaseRoute(NAVBAR_ROUTES.createClient, clientId, caseId)}>
        <button
          className="inbox-icon text-center hover-co icon-hover-container"
          style={{ paddingRight: "0px" }}
        >
          <img
            className="height-41 header-lg-icon"
            src="/BP_resources/images/icon/add-new-case-logo-icon.svg"
            alt="Add New Case logo"
          />
          <small className="inbox-hover-text">Add New Case</small>
        </button>
      </Link>
      {/* <ModalComponent show={showModal} onClose={handleCloseModal} /> */}
    </div>
  );
  const inboxDiv = (
    <div
      style={{
        cursor: "pointer",
        ...(!isCollapseInbox
          ? {
              left: isCollapseAddNewCase ? "0px" : "-10px",
              marginRight: isCollapseAddNewCase ? "15px" : "5px",
              marginTop: "5px",
              position: "relative",
              height: "64px",
            }
          : {
              marginRight: "0px",
              marginTop: "0px",
              position: "unset",
              left: "0px",
            }),
      }}
      {...getRootProps({ onClick: (event) => event.stopPropagation() })}
      className="case-btn icon-hover-container inbox-icon"
    >
      <input {...getInputProps()} />
      <Link to={buildCaseRoute(NAVBAR_ROUTES.inbox, clientId, caseId)}>
        <button
          className="inbox-icon text-center hover-co icon-hover-container"
          style={{ paddingLeft: "0px" }}
        >
          <img
            className="height-41 header-lg-icon"
            src="/BP_resources/images/icon/inbox-logo-icon.svg"
            alt="Inbox logo"
          />
          <small className="inbox-hover-text">Inbox</small>
        </button>
      </Link>
    </div>
  );
  const dropdownAddNewCaseDiv = (
    <div
      className="case-btn icon-hover-container add-case-btn navbar-icon-button flex-column"
      style={{
        ...(!isCollapseAddNewCase
          ? {
              left: "-10px",
              marginRight: "5px",
              marginTop: "5px",
              position: "relative",
            }
          : {
              marginRight: "0px",
              marginTop: "0px",
              position: "unset",
              left: "0px",
            }),
      }}
    >
      <Link to={buildCaseRoute(NAVBAR_ROUTES.createClient, clientId, caseId)}>
        <button
          className="text-center hover-co icon-hover-container m-r-5"
          style={{ paddingRight: "0px", width: "66px" }}
        >
          <img
            className="height-41 header-lg-icon"
            src="/BP_resources/images/icon/add-new-case-logo-icon.svg"
            alt="Add New Case logo"
          />
        </button>
      </Link>
      <small className="header-dropdown-text">Add New Case</small>
      {/* <ModalComponent show={showModal} onClose={handleCloseModal} /> */}
    </div>
  );
  const dropdownInboxDiv = (
    <div
      style={{
        cursor: "pointer",
        marginRight: "0px",
        marginTop: "0px",
        position: "unset",
        left: "0px",
      }}
      {...getRootProps({ onClick: (event) => event.stopPropagation() })}
      className="case-btn icon-hover-container navbar-icon-button flex-column"
    >
      <input {...getInputProps()} />
      <Link to={buildCaseRoute(NAVBAR_ROUTES.inbox, clientId, caseId)}>
        <button
          className="text-center hover-co icon-hover-container m-l-5"
          style={{ paddingLeft: "0px", width: "66px" }}
        >
          <img
            className="height-41 header-lg-icon"
            src="/BP_resources/images/icon/inbox-logo-icon.svg"
            alt="Inbox logo"
          />
        </button>
      </Link>
      <small className="header-dropdown-text">Inbox</small>
    </div>
  );

  const currentCase = useSelector((state) => state?.caseData?.current);

  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest(".more-2")
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="top-nav-wrapper-inner navbar-links-container-menu-collapsible d-flex d-flex-1 right-in d-block"
      ref={navbarContainerRef}
      style={{ zIndex: 10000, cursor: "pointer", position: "relative", left: "-1px" }}
    >
      <div
        className="bar Header-z-index-0"
        style={{
          cursor: "pointer",
        }}
      >
        <div className="wrap stacked-icons p-t-5" style={{ height: "50px", cursor: "pointer" }}>
          <ul className="list-unstyled" id="main-2">
            <li className="padding-right-9">
              {CustomLink(
                homeMenuItem.clickId,
                homeMenuItem.pageId,
                homeMenuItem.path,
                homeMenuItem.icon,
                homeMenuItem.badgetCount,
                homeMenuItem.linkText,
                false
              )}
            </li>
            {visibleMenuItems.map((menuItem) =>
              menuItem.linkText === "Home Page" ? null : ["User Options"].includes(
                  menuItem.linkText
                ) ? (
                <>
                  <li className="padding-right-9">
                    {CustomOptions(
                      () => {
                        handleSettingsClick();
                      },
                      menuItem.icon,
                      menuItem.linkText,
                      false
                    )}
                  </li>
                </>
              ) : (
                <li className="padding-right-9">
                  {CustomLink(
                    menuItem.clickId,
                    menuItem.pageId,
                    menuItem.path,
                    menuItem.icon,
                    menuItem.badgetCount,
                    menuItem.linkText,
                    false
                  )}
                </li>
              )
            )}
            {hiddenMenuItems.length === 0 ? null : (
              <li
                className="d-none more-2 hidden show-dropdown-menu-icon"
                data-width="40"
                style={{
                  cursor: "pointer",
                }}
              >
                <button
                  onClick={() => setDropdownOpen((prev) => !prev)}
                  // className={`navbar-icon-button ${hiddenMenuItems.length === 0 ? "hidden" : ""}`}
                  className="navbar-icon-button"
                >
                  <span
                    className="ic ic-17 h-100 has-no-after text-white d-flex align-items-center justify-content-center"
                    style={{ transform: "translateY(-5px)" }}
                  >
                    <svg
                      width="17"
                      height="50"
                      viewBox="0 0 17 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 16H4.59998L8.5 19.95L12.4 16H17L8.5 24.55L0 16Z"
                        fill="currentColor"
                      />
                      <path
                        d="M0 25.4512H4.59998L8.5 29.4012L12.4 25.4512H17L8.5 34.0012L0 25.4512Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </button>

                {dropdownOpen && (
                  <div
                    ref={dropdownRef}
                    className="navbar-dropdown-menu navbar-relative"
                    style={{ width: "334px", cursor: "pointer" }}
                  >
                    {hiddenMenuItems.map((menuItem) =>
                      ["User Options"].includes(menuItem.linkText) ? (
                        <>
                          <li className="padding-right-9">
                            {CustomOptions(
                              () => {
                                handleSettingsClick();
                              },
                              menuItem.icon,
                              menuItem.linkText,
                              true
                            )}
                          </li>
                        </>
                      ) : (
                        CustomLink(
                          menuItem.clickId,
                          menuItem.pageId,
                          menuItem.path,
                          menuItem.icon,
                          menuItem.badgetCount,
                          menuItem.linkText,
                          true
                        )
                      )
                    )}

                    {!isCollapseAddNewCase ? null : dropdownAddNewCaseDiv}

                    {!isIconsvisible ? null : dropdownInboxDiv}
                  </div>
                )}
              </li>
            )}
          </ul>
        </div>
        <div
          className="position-absolute"
          style={{ bottom: "0px", left: "-6px", cursor: "pointer" }}
          id="stage-labels"
        >
          <Stages stageCase={currentCase} stages={stages} classes="d-flex" />
          <div
            className=""
            style={{
              position: "absolute",
              bottom: "0rem",
              right: "-6px",
              width: "0px",
              height: "25px",
              backgroundColor: "var(--primary)",
              padding: "5px",
              transform: "skewX(11.31deg)",
              zIndex: 999,
              cursor: "pointer",
            }}
          />
        </div>
      </div>
      <>
        {isCollapseAddNewCase ? null : addNewCaseDiv}
        {isCollapseInbox ? null : inboxDiv}
        <DocumentUploadModal
          uploadFile={uploadFile}
          uploadProgress={uploadProgress}
          id="fileModal"
          show={fileUploadModal}
          onHide={() => setFileUploadModal(false)}
        />
        {isSettingsOpen && (
          <UserPreference show={isSettingsOpen} handleClose={() => setIsSettingsOpen(false)} />
        )}
      </>
    </div>
  );
};

export default NavbarLinks;
